module.exports = __webpack_public_path__ + "img/3.f1bb6e64.webp";